import axios from "axios";
import Cookies from "js-cookie";
const { REACT_APP_API_URL } = process.env;
const { REACT_APP_URL } = process.env;

axios.defaults.baseURL = `${REACT_APP_API_URL}`;
const lang = Cookies.get("lang");
axios.defaults.headers.common["lang"] = lang || "ar";
axios.defaults.headers.common["Access-Control-Allow-Origin"] =
    REACT_APP_URL || "http://localhost:3000";
axios.defaults.withCredentials = true;
// axios.defaults
axios.defaults.headers.common["Access-Control-Allow-Origin"] = REACT_APP_URL;
